import { render } from "./ItemTotalSummary.vue?vue&type=template&id=d9524514"
import script from "./ItemTotalSummary.vue?vue&type=script&lang=js"
export * from "./ItemTotalSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__